import React from 'react'
import type { TestimonialCardProps } from './types'
import { twMerge } from 'tailwind-merge'

export const TestimonialCard = ({
  className,
  children,
  ...rest
}: TestimonialCardProps): JSX.Element => (
  <figure className={twMerge('testimonial-card', className)} {...rest}>
    {children}
  </figure>
)

export default TestimonialCard
